/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/location';
import '../../common/countries';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "fiscalreporter": {
        "nested": {
          "model": {
            "nested": {
              "IdentificationType": {
                "values": {
                  "UNKNOWN": 0,
                  "TAX_NUMBER": 1,
                  "PASSPORT": 2,
                  "DOCUMENT": 3,
                  "CERTIFICATE": 4,
                  "OTHER": 5
                }
              },
              "InvoiceRecipient": {
                "fields": {
                  "identificationType": {
                    "type": ".squareup.fiscalreporter.model.IdentificationType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "id": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "legalName": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "globalAddress": {
                    "type": ".squareup.common.location.GlobalAddress",
                    "id": 4,
                    "rule": "optional"
                  },
                  "identificationCountryOfIssue": {
                    "type": ".squareup.common.countries.Country",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "InvoiceSequentialNumber": {
                "fields": {
                  "series": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "number": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "delimiter": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "VerifactuInvoiceCompliance": {
                "fields": {
                  "text": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "url": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "qrCode": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "imageUrl": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "TicketbaiInvoiceCompliance": {
                "fields": {
                  "tbaiIdentificationCode": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "url": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "qrCode": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "imageUrl": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "WebSrmInvoiceCompliance": {
                "fields": {
                  "deviceIdentifier": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "gstNumber": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "qstNumber": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "transactionNumber": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "websrmTransactionNumber": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "websrmProcessedDate": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "qrCodeUrl": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "qrCodeImageUrl": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "isOffline": {
                    "type": "bool",
                    "id": 9,
                    "rule": "optional"
                  },
                  "batchNumber": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  }
                }
              },
              "InvoiceCompliance": {
                "fields": {
                  "verifactuInvoiceCompliance": {
                    "type": ".squareup.fiscalreporter.model.VerifactuInvoiceCompliance",
                    "id": 1
                  },
                  "ticketbaiInvoiceCompliance": {
                    "type": ".squareup.fiscalreporter.model.TicketbaiInvoiceCompliance",
                    "id": 2
                  },
                  "websrmInvoiceCompliance": {
                    "type": ".squareup.fiscalreporter.model.WebSrmInvoiceCompliance",
                    "id": 3
                  }
                },
                "nested": {
                  "invoice_compliance": {
                    "oneof": ["verifactuInvoiceCompliance", "ticketbaiInvoiceCompliance", "websrmInvoiceCompliance"]
                  }
                }
              },
              "OrderData": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "version": {
                    "type": "int32",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "InvoiceFiscalData": {
                "fields": {
                  "invoiceSequentialNumber": {
                    "type": ".squareup.fiscalreporter.model.InvoiceSequentialNumber",
                    "id": 1,
                    "rule": "optional"
                  },
                  "invoiceRecipient": {
                    "type": ".squareup.fiscalreporter.model.InvoiceRecipient",
                    "id": 2,
                    "rule": "optional"
                  },
                  "invoiceCompliance": {
                    "type": ".squareup.fiscalreporter.model.InvoiceCompliance",
                    "id": 3,
                    "rule": "optional"
                  },
                  "sourceOrder": {
                    "type": ".squareup.fiscalreporter.model.OrderData",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.fiscalreporter?.nested?.model?.nested?.IdentificationType && !$root.nested?.squareup?.nested?.fiscalreporter?.nested?.model?.nested?.InvoiceRecipient && !$root.nested?.squareup?.nested?.fiscalreporter?.nested?.model?.nested?.InvoiceSequentialNumber && !$root.nested?.squareup?.nested?.fiscalreporter?.nested?.model?.nested?.VerifactuInvoiceCompliance && !$root.nested?.squareup?.nested?.fiscalreporter?.nested?.model?.nested?.TicketbaiInvoiceCompliance && !$root.nested?.squareup?.nested?.fiscalreporter?.nested?.model?.nested?.WebSrmInvoiceCompliance && !$root.nested?.squareup?.nested?.fiscalreporter?.nested?.model?.nested?.InvoiceCompliance && !$root.nested?.squareup?.nested?.fiscalreporter?.nested?.model?.nested?.OrderData && !$root.nested?.squareup?.nested?.fiscalreporter?.nested?.model?.nested?.InvoiceFiscalData) {
  $root.addJSON(jsonData);
}

/**
 * Customer or business identification type.
 *
 * SOURCE IdentificationType @ squareup/fiscalreporter/model/invoice_fiscal_data.proto at 18:1
 */
export const IdentificationType = $root.lookupEnum('squareup.fiscalreporter.model.IdentificationType').values;
/**
 * Customer or business information for the purpose of displaying on receipts/invoices (a.k.a. complete invoices).
 *
 * SOURCE InvoiceRecipient @ squareup/fiscalreporter/model/invoice_fiscal_data.proto at 41:1
 */
export const InvoiceRecipient = $root.lookupType('squareup.fiscalreporter.model.InvoiceRecipient');
fixType(InvoiceRecipient);
Builder.createAndAttachToType(InvoiceRecipient);
/**
 * A unique, sequential number of the invoice (multiple series are allowed, subject to certain guidelines).
 *
 * SOURCE InvoiceSequentialNumber @ squareup/fiscalreporter/model/invoice_fiscal_data.proto at 61:1
 */
export const InvoiceSequentialNumber = $root.lookupType('squareup.fiscalreporter.model.InvoiceSequentialNumber');
fixType(InvoiceSequentialNumber);
Builder.createAndAttachToType(InvoiceSequentialNumber);
/**
 * VeriFactu invoice compliance data in Spain (applies outside of Basque country).
 *
 * SOURCE VerifactuInvoiceCompliance @ squareup/fiscalreporter/model/invoice_fiscal_data.proto at 75:1
 */
export const VerifactuInvoiceCompliance = $root.lookupType('squareup.fiscalreporter.model.VerifactuInvoiceCompliance');
fixType(VerifactuInvoiceCompliance);
Builder.createAndAttachToType(VerifactuInvoiceCompliance);
/**
 * TicketBAI invoice compliance data in Spain (applies within Basque country).
 *
 * SOURCE TicketbaiInvoiceCompliance @ squareup/fiscalreporter/model/invoice_fiscal_data.proto at 92:1
 */
export const TicketbaiInvoiceCompliance = $root.lookupType('squareup.fiscalreporter.model.TicketbaiInvoiceCompliance');
fixType(TicketbaiInvoiceCompliance);
Builder.createAndAttachToType(TicketbaiInvoiceCompliance);
/**
 * WEB-SRM invoice compliance data for Quebec, Canada.
 *
 * SOURCE WebSrmInvoiceCompliance @ squareup/fiscalreporter/model/invoice_fiscal_data.proto at 109:1
 */
export const WebSrmInvoiceCompliance = $root.lookupType('squareup.fiscalreporter.model.WebSrmInvoiceCompliance');
fixType(WebSrmInvoiceCompliance);
Builder.createAndAttachToType(WebSrmInvoiceCompliance);
/**
 * Invoice compliance data.
 *
 * SOURCE InvoiceCompliance @ squareup/fiscalreporter/model/invoice_fiscal_data.proto at 134:1
 */
export const InvoiceCompliance = $root.lookupType('squareup.fiscalreporter.model.InvoiceCompliance');
fixType(InvoiceCompliance);
Builder.createAndAttachToType(InvoiceCompliance);
/**
 * SOURCE OrderData @ squareup/fiscalreporter/model/invoice_fiscal_data.proto at 143:1
 */
export const OrderData = $root.lookupType('squareup.fiscalreporter.model.OrderData');
fixType(OrderData);
Builder.createAndAttachToType(OrderData);
/**
 * Invoice fiscal data consisting of sequential number, recipient information and invoice compliance data.
 *
 * SOURCE InvoiceFiscalData @ squareup/fiscalreporter/model/invoice_fiscal_data.proto at 152:1
 */
export const InvoiceFiscalData = $root.lookupType('squareup.fiscalreporter.model.InvoiceFiscalData');
fixType(InvoiceFiscalData);
Builder.createAndAttachToType(InvoiceFiscalData);